import BaseService from '../../../infrastructure/services';

export const getAllPlanos = async () => {
  const customConfig = {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
    },
  };

  const response = await BaseService.get(`/Plano/ObterTodos?pageNumber=1&pageSize=1000`, customConfig);
  return response.data;
}
